import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export function LoginProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateUser = async () => {
    try {
      const authToken = localStorage.getItem("token");

      if (!authToken) {
        setError("User is not logged in");
        setIsLoading(false);
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await axios.get(
        `${process.env.REACT_APP_DOMAIN_URL}/api/user`,

        config
      );
      const userData = response.data;
      setUser(userData);

      setIsLoading(false);
      setError(null);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateUser(); // Initialize user authentication state
  }, []);

  const logout = async () => {
    try {
      const authToken = localStorage.getItem("token");
      // console.log("authToken", authToken);

      if (!authToken) {
        setError("User is not logged in");
        setIsLoading(false);
        return;
      }

      localStorage.removeItem("token");

      setUser(null);
      setIsLoading(false);
      setError(null);
      // window.location.reload();
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, isLoading, error, logout, updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}
